<script setup>
  import { computed } from 'vue';
  import { isToday, isYesterday } from 'date-fns';
import { is } from 'date-fns/locale';

  const props = defineProps({
    validDate: {
      type: String,
      required: true
    },
    timezone: {
      type: String,
      default: true
    }
  });

  const morningOf = computed(() => {
    const date = new Date(`${props.validDate} ${props.timezone}`);

    return isToday(date) ? "tomorrow morning" : isYesterday(date) ? "this morning" : "tomorrow morning";
  });

</script>
<template>
  <div class="jwx-pro-forecast__body">
    <section class="jwx-page__section">
      <div class="jwx-pro-forecast__block jwx-block">
        <div class="jwx-block__body-content">
          <p class="jwx-pro-forecast__text" data-size="lg">A fresh weather forecast will be posted by 8:00 AM {{ morningOf }}. Our meteorologist will provide you with the most accurate and detailed weather outlook for the region at that time.</p>
          <p class="jwx-pro-forecast__text" data-size="lg"> Check back {{ morningOf }} for the latest conditions and forecast!</p>
        </div>
      </div>
    </section>
  </div>
</template>